import {put, takeLatest} from "redux-saga/effects";
import * as actionTypes from '../actions/actionTypes';
import {fetchTimezoneList} from '../../api/settings';
// import * as actions from '../actions/session';
// import history from '../../history';

export default function* sessionSaga() {
    yield takeLatest(actionTypes.REQUEST_TIMEZONE_LIST, function* requestTimezoneList() {
        try {
            const {data: {data}} = yield fetchTimezoneList();

            yield put({
                type: actionTypes.TIMEZONES_FETCH_SUCCEEDED,
                payload: {
                    timezones: data
                }
            });
        } catch (e) {

        }
    });
}
